import Api from './api'

export default {
    getPlace() {
        let host = window.location.hostname
        let place_hash = window.location.pathname
        let search = window.location.search
        place_hash = place_hash.replace(/^\/|\/$/g, '')
        return Api.get('place/place/getbyhash?host=' + host + '&place_hash=' + place_hash + '&extra=' + search).then(response => {
            if (response.data.ok) {
                return response.data.response
            } else {
                return false
            }
        });
    }
};